__turbopack_context__.v({
  "bazaarvoice-review-stars-input": "bazaarvoice-review-stars-input-component-module-scss-module__enmCgW__bazaarvoice-review-stars-input",
  "bazaarvoice-review-stars-input__star": "bazaarvoice-review-stars-input-component-module-scss-module__enmCgW__bazaarvoice-review-stars-input__star",
  "bazaarvoice-review-stars-input__star--filled": "bazaarvoice-review-stars-input-component-module-scss-module__enmCgW__bazaarvoice-review-stars-input__star--filled",
});
